import { render, staticRenderFns } from "./TabMap.vue?vue&type=template&id=7f84bd94&"
import script from "./TabMap.vue?vue&type=script&lang=js&"
export * from "./TabMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports